import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { BaseViewComponent } from '@sb/library/base';

@Component({
    selector: 'lib-chip-button',
    templateUrl: './chip-button.component.html',
})
export class ChipButtonComponent extends BaseViewComponent {

    @Input() menuTrigger!: MatMenu | null;
    @Input() hasCarretSuffix: boolean = false;
    @Input() qaTag: string  = '';
    @ViewChild(MatMenuTrigger) matMenuTrigger!: MatMenuTrigger;

    @Output() click: EventEmitter<void> = new EventEmitter<void>;

    Clicked(): void {
        this.click.emit();
    }

    CloseMenu(): void {
        this.matMenuTrigger.closeMenu();
    }
}
